<template>
</template>

<script>
  export default {
    props: {
      item: Object
    },

    computed: {
      /**
       * @return {string}
       */
      url() {
        return _.get(this.item, 'model.full_url');
      },

      /**
       * @return {string}
       */
      mimeType() {
        return _.get(this.item, 'model.mime_type');
      },
    },

    methods: {
      /**
       * @event open-media-show-dialog
       */
      openDialog() {
        this.$emit('open-media-dialog', {
          url: this.url,
          mimeType: this.mimeType,
        });
      },
    },
  }
</script>
